import { MODAL_LISTENERS } from '../types'

export const openModalAction = (): void => {
  window.dispatchEvent(new CustomEvent(MODAL_LISTENERS.OPEN))
}

export const closeModalAction = (): void => {
  window.dispatchEvent(new CustomEvent(MODAL_LISTENERS.CLOSE))
}
